// Translation data extracted from CSV
const translations = {
  pt: {
    // Header/Banner
    "linha_protheus": "Linha Protheus",
    "atualizacao_release": "Atualização do release",
    "informacoes_gerais": "Informações gerais sobre o release",
    "destaques_principais": "Destaques principais do release",

    // Versions
    "check_other_versions": "Confira outras versões do Protheus aqui",
    "check_other_versions_short": "Outras versões",
    "versions_page_title": "Versões do Protheus",
    "versions_page_subtitle": "Selecione uma versão do release para visualizar suas informações",
    "versions_view_release": "Ver release",
    "versions_latest_badge": "Mais recente",

    // Cards
    "reforma_tributaria": "Reforma Tributária",
    "implementacoes_seguranca": "Implementações importantes em segurança",
    "implementacoes_seguranca_texto": "A TOTVS sempre está preocupada com a segurança em seus produtos, implementou neste release dois novos pontos que podem ter impacto nas customizações e/ou usuários do sistema.\n\nPrincipais Implementações:\n- Restrições na atribuição das variáveis cEmpAnt e __cUserId\nA partir da release 12.1.2510 do Protheus, a atribuição direta às variáveis globais cEmpAnt (grupo de empresa) e __cUserId (usuário) foi bloqueada por motivos de segurança e integridade de dados. A leitura dessas variáveis continua permitida. É preciso rever as customizações que fazem este tipo de ação. Uma ferramenta que ajuda a identificar este pontos é o CodeAnalysis.\n\n- Novas Políticas obrigatórias para criação e atualização de Senhas no Protheus\nCom o objetivo de fortalecer a proteção do nosso sistema ERP, estamos implementando novas e mais rigorosas regras para a criação e atualização de senhas.",
    "recomendacoes_hardware": "Recomendações de hardware",
    "descontinuacao_ctree": "Descontinuação do C-tree Server",
    "acesso_rapido": "Acesso rápido aos artefatos",
    "uso_obrigatorio_privilegios": "Uso obrigatório de privilégios",
    "pontos_atencao_release": "Pontos de Atenção do Release",
    "nova_home_novo_browse": "Nova Home & Visão",
    "protheus_insights": "Protheus Insights",
    "novidades_release": "Novidades do release",
    
    // Solutions
    "solucoes_cross": "Soluções Cross",
    "backoffice": "Backoffice",
    "recursos_humanos": "Recursos Humanos",
    "taf_automacao": "TAF Automação Fiscal",
    "tss": "TSS",
    "solucao_segmentos": "Solução de Segmentos",
    "juridico": "Jurídico",
    "manufatura": "Manufatura",
    "saude": "Saúde",
    "varejo": "Varejo",
    "logistica": "Logística",
    "locacao": "Locação",
    "gestao_agricola": "Gestão Agrícola",
    "professional_services": "Professional Services",
    
    // Documentation
    "documentacao_produto": "Documentação do Produto",
    "melhorias": "Melhorias",
    "legislacao": "Legislação",
    "manutencao": "Manutenção",
    
    // Content Boxes
    "framework": "Framework",
    "framework_texto": "O Framework Protheus passou por diversas melhorias na Release 12.1.2510, focando em otimização, segurança e usabilidade para proporcionar uma experiência ainda melhor aos desenvolvedores e usuários finais.\n\nRelease Notes do Framework Protheus",
    "tecnologia": "Tecnologia",
    "tecnologia_texto": "Principais Atualizações de Tecnologia:\n- Application Server - 24.3.1.0\n- DBAccess - 24.1.1.0\n- Broker HA - Alta disponibilidade\n- Application Server - Descontinuação do c-tree server e bound server\n- Página principal do WebApp\n  Informações técnicas importantes sobre o WebApp.\n- Migrando do SmartClient Desktop para o WebApp\n  Informações sobre as diferenças de comportamento entre a versão Desktop e a versão Web, e mais dicas importantes para a migração.\n- WebApp - Configuração de SSL/TLS\n  Informações para configuração de seu ambiente utilizando o Broker e a Porta Multiprotocolo.",
    "cloud": "Cloud",
    "cloud_texto": "Explore os recursos e documentação do Protheus Cloud para uma experiência completa na nuvem.\n\nRecursos Disponíveis:\n- Central de Atendimento - TOTVS Cloud - Linha Protheus\n  Encontre respostas para suas dúvidas em quatro fontes de conhecimento diferentes ao mesmo tempo, simplificando o processo de pesquisa.\n\n- Playlist de Vídeos HOW TO - TOTVS Cloud\n  Assista aos vídeos tutoriais sobre o TOTVS Cloud em nossa playlist no YouTube.",
    
    // Central Panel
    "recursos_adicionais": "Recursos Adicionais do Protheus",
    "conheca_centrais": "Conheça as Centrais do Protheus",
    "avalie_fontes": "Avalie seus fontes no CodeAnalysis",
    "tir_robot": "TIR Test Interface Robot",
    "links_uteis": "Links úteis",
    "recursos_recomendacoes_hardware": "Recomendações de Hardware",
    "links_uteis_texto": "Acesse os principais links e documentações para o Protheus:\n\nCiclo de Vida de Software - Página Corporativa\nCiclo de Vida de Software - TOTVS Linha Protheus\nEngenharia Protheus\nGuia de Instalação do Protheus 12\nPortal do cliente\nRecomendações de hardware\nRelease anterior: Release 12.1.2410 - Expedição em Outubro/2024\nRotinas do Protheus Descontinuadas",
    
    // Chatbot
    "chatbot_message": "Olá, para mais perguntas sobre o Release 12.1.2510, clique aqui e pergunte ao nosso assistente virtual!",
    "chatbot_message_2610": "Olá, para mais perguntas sobre o Release 12.1.2610, clique aqui e pergunte ao nosso assistente virtual!",
    "chatbot_title_2610": "Assistente Protheus Release",
    "chat_thinking_2610": "Consultando a documentação",
    
    // ChatInitModal
    "chat_init_title": "Iniciar Chat com Assistente",
    "chat_init_description": "Para iniciar uma conversa com nosso assistente virtual, precisamos de algumas informações:",
    "email_label": "E-mail",
    "email_placeholder": "Digite seu e-mail",
    "security_verification_label": "Verificação de Segurança",
    "initialize_chat_button": "Inicializar Chat",
    "send_verification_button": "Enviar Código de Verificação",
    "sending_verification_button": "Enviando código...",
    "initializing_button": "Inicializando...",
    "privacy_note": "Ao inicializar este chat, você concorda que seu email seja armazenado exclusivamente para melhorar sua experiência com o assistente virtual e que não será compartilhado com terceiros.",
    "email_required_error": "Por favor, insira seu e-mail.",
    "email_invalid_error": "Por favor, insira um e-mail válido.",
    "recaptcha_required_error": "Por favor, complete o reCaptcha.",
    "recaptcha_load_error": "Falha ao carregar o reCaptcha. Tente novamente.",
    "recaptcha_init_error": "Erro ao inicializar o reCaptcha. Tente recarregar a página.",
    "recaptcha_expired_error": "O reCaptcha expirou. Por favor, complete novamente.",
    "recaptcha_error": "Erro no reCaptcha. Tente novamente.",
    "chat_init_error": "Erro ao inicializar o chat. Tente novamente.",
    "verification_send_error": "Erro ao enviar código de verificação. Tente novamente.",
    "verification_network_error": "Erro de rede. Verifique sua conexão e tente novamente.",
    
    // Email Verification Modal
    "email_verification_title": "Verificar E-mail",
    "email_verification_description": "Enviamos um código de 6 dígitos para o seu e-mail:",
    "verification_code_label": "Código de Verificação",
    "verification_code_placeholder": "000000",
    "code_expires_in": "O código expira em:",
    "code_expired": "O código expirou.",
    "resend_code_button": "Reenviar Código",
    "verify_email_button": "Verificar E-mail",
    "verifying_button": "Verificando...",
    "verification_help_text": "Não recebeu o código? Verifique sua caixa de spam ou aguarde alguns minutos.",
    "token_required_error": "Por favor, insira o código de verificação.",
    "token_invalid_length_error": "O código deve ter 6 dígitos.",
    "verification_failed_error": "Código inválido ou expirado. Tente novamente.",
    "verification_error": "Erro de rede durante a verificação. Tente novamente.",
    "resend_failed_error": "Erro ao reenviar código. Tente novamente.",
    "resend_network_error": "Erro de rede ao reenviar código. Tente novamente."
  },
  
  en: {
    // Header/Banner
    "linha_protheus": "Protheus Line",
    "atualizacao_release": "Release Update",
    "informacoes_gerais": "General information about the Release",
    "destaques_principais": "Main highlights of the release",

    // Versions
    "check_other_versions": "Check other Protheus versions here",
    "check_other_versions_short": "Other versions",
    "versions_page_title": "Protheus Versions",
    "versions_page_subtitle": "Select a release version to view its information",
    "versions_view_release": "View release",
    "versions_latest_badge": "Latest",

    // Cards
    "reforma_tributaria": "Tax Reform",
    "implementacoes_seguranca": "Important security implementations",
    "implementacoes_seguranca_texto": "TOTVS is always concerned about security in its products. In this release, it has implemented two new features that may impact customizations and/or system users.\n\nMain Implementations:\n - Restrictions on assigning cEmpAnt and __cUserId variables\nStarting with Protheus release 12.1.2510, direct assignment to the global variables cEmpAnt (company group) and __cUserId (user) has been blocked for security and data integrity reasons. Reading these variables remains permitted. Customizations that perform this type of action should be reviewed. CodeAnalysis is a tool that helps identify these issues.\n\n- New Mandatory Policies for Creating and Updating Passwords in Protheus\nTo strengthen the protection of our ERP system, we are implementing new, stricter rules for creating and updating passwords.",
    "recomendacoes_hardware": "Hardware recomendations",
    "descontinuacao_ctree": "C-tree Server Discontinuation",
    "acesso_rapido": "Quick access to artifacts",
    "uso_obrigatorio_privilegios": "Mandatory use of privileges",
    "pontos_atencao_release": "Release Points of Attention",
    "nova_home_novo_browse": "New Home & Vision",
    "protheus_insights": "Protheus Insights",
    "novidades_release": "Release News",
    
    // Solutions
    "solucoes_cross": "Cross Solutions",
    "backoffice": "Backoffice",
    "recursos_humanos": "Human Resources",
    "taf_automacao": "TAF Tax Automation",
    "tss": "TSS",
    "solucao_segmentos": "Segment Solution",
    "juridico": "Legal",
    "manufatura": "Manufacturing",
    "saude": "Health",
    "varejo": "Retail",
    "logistica": "Logistics",
    "locacao": "Rental",
    "gestao_agricola": "Agricultural Management",
    "professional_services": "Professional Services",
    
    // Documentation
    "documentacao_produto": "Product Documentation",
    "melhorias": "Innovations",
    "legislacao": "Legislation",
    "manutencao": "Maintenance",
    
    // Content Boxes
    "framework": "Framework",
    "framework_texto": "The Protheus Framework has undergone several improvements in Release 12.1.2510, focusing on optimization, security, and usability to provide an even better experience for developers and end users.\n\nRelease Notes do Framework Protheus",
    "tecnologia": "Technology",
    "tecnologia_texto": "Main Technology Updates:\n- Application Server - 24.3.1.0\n- DBAccess - 24.1.1.0\n- Broker HA - High Availability\n- Application Server - Discontinuation of the c-tree server and bound server\n- WebApp Home Page\n  Important technical information about the WebApp.\n- Migrating from SmartClient Desktop to the WebApp\n  Information on the behavioral differences between the Desktop and Web versions, and other important migration tips.\n- WebApp - SSL/TLS Configuration\n  Information on configuring your environment using the Broker and the Multiprotocol Port.",
    "cloud": "Cloud",
    "cloud_texto": "Explore Protheus Cloud features and documentation for a complete cloud experience.\n\nAvailable Resources:\n- Customer Service - TOTVS Cloud - Protheus Line\nFind answers to your questions from four different knowledge sources simultaneously, simplifying the search process.\n\n- HOW-TO Video Playlist - TOTVS Cloud\nWatch tutorial videos about TOTVS Cloud on our YouTube playlist.",
    
    // Central Panel
    "recursos_adicionais": "Additional Features of Protheus",
    "conheca_centrais": "Get to know the Protheus Centers",
    "avalie_fontes": "Evaluate your program sources in Codeanalysis",
    "tir_robot": "TIR Test Interface Robot",
    "links_uteis": "Useful links",
    "recursos_recomendacoes_hardware": "Hardware Recommendations",
    "links_uteis_texto": "Access the main links and documentation for Protheus:\n\nSoftware Lifecycle - Corporate Page\nSoftware Lifecycle - TOTVS Protheus Line\nProtheus Engineering\nProtheus 12 Installation Guide\nCustomer Portal\nHardware Recommendations\nPrevious Release: Release 12.1.2410 - Expedition in October 2024\nDiscontinued Protheus Routines",
    
    // Chatbot
    "chatbot_message": "Hi, for more information about Release 12.1.2510, click here and ask our virtual assistant!",
    "chatbot_message_2610": "Hi, for more information about Release 12.1.2610, click here and ask our virtual assistant!",
    "chatbot_title_2610": "Protheus Release Assistant",
    "chat_thinking_2610": "Searching the documentation",
    
    // ChatInitModal
    "chat_init_title": "Start Chat with Assistant",
    "chat_init_description": "To start a conversation with our virtual assistant, we need some information:",
    "email_label": "Email",
    "email_placeholder": "Enter your email",
    "security_verification_label": "Security Verification",
    "initialize_chat_button": "Initialize Chat",
    "send_verification_button": "Send Verification Code",
    "sending_verification_button": "Sending code...",
    "initializing_button": "Initializing...",
    "privacy_note": "By initializing this chat, you agree that your email will be stored exclusively to improve your experience with the virtual assistant and will not be shared with third parties.",
    "email_required_error": "Please enter your email.",
    "email_invalid_error": "Please enter a valid email.",
    "recaptcha_required_error": "Please complete the reCaptcha.",
    "recaptcha_load_error": "Failed to load reCaptcha. Please try again.",
    "recaptcha_init_error": "Error initializing reCaptcha. Please reload the page.",
    "recaptcha_expired_error": "The reCaptcha has expired. Please complete it again.",
    "recaptcha_error": "reCaptcha error. Please try again.",
    "chat_init_error": "Error initializing chat. Please try again.",
    "verification_send_error": "Error sending verification code. Please try again.",
    "verification_network_error": "Network error. Check your connection and try again.",
    
    // Email Verification Modal
    "email_verification_title": "Verify Email",
    "email_verification_description": "We sent a 6-digit code to your email:",
    "verification_code_label": "Verification Code",
    "verification_code_placeholder": "000000",
    "code_expires_in": "Code expires in:",
    "code_expired": "The code has expired.",
    "resend_code_button": "Resend Code",
    "verify_email_button": "Verify Email",
    "verifying_button": "Verifying...",
    "verification_help_text": "Didn't receive the code? Check your spam folder or wait a few minutes.",
    "token_required_error": "Please enter the verification code.",
    "token_invalid_length_error": "The code must be 6 digits.",
    "verification_failed_error": "Invalid or expired code. Please try again.",
    "verification_error": "Network error during verification. Please try again.",
    "resend_failed_error": "Error resending code. Please try again.",
    "resend_network_error": "Network error while resending code. Please try again."
  },
  
  es: {
    // Header/Banner
    "linha_protheus": "Línea Protheus",
    "atualizacao_release": "Actualización de release",
    "informacoes_gerais": "Información general sobre el Release",
    "destaques_principais": "Principales aspectos destacados del release",

    // Versions
    "check_other_versions": "Consulta otras versiones de Protheus aquí",
    "check_other_versions_short": "Otras versiones",
    "versions_page_title": "Versiones de Protheus",
    "versions_page_subtitle": "Seleccione una versión del release para ver su información",
    "versions_view_release": "Ver release",
    "versions_latest_badge": "Más reciente",

    // Cards
    "reforma_tributaria": "Reforma Fiscal",
    "implementacoes_seguranca": "Implementaciones de seguridad importantes",
    "implementacoes_seguranca_texto": "TOTVS se preocupa constantemente por la seguridad de sus productos. En esta versión, ha implementado dos nuevas funciones que podrían afectar las personalizaciones o a los usuarios del sistema.\n\nImplementaciones principales:\n- Restricciones en la asignación de las variables cEmpAnt y __cUserId\nA partir de la versión 12.1.2510 de Protheus, se ha bloqueado la asignación directa a las variables globales cEmpAnt (grupo empresarial) y __cUserId (usuario) por motivos de seguridad e integridad de los datos. La lectura de estas variables sigue permitida. Se recomienda revisar las personalizaciones que realizan este tipo de acción. CodeAnalysis es una herramienta que ayuda a identificar estos problemas.\n\n- Nuevas políticas obligatorias para la creación y actualización de contraseñas en Protheus\nPara reforzar la protección de nuestro sistema ERP, estamos implementando nuevas reglas más estrictas para la creación y actualización de contraseñas.",
    "recomendacoes_hardware": "Recomendaciones de hardware",
    "descontinuacao_ctree": "Interrupción del servidor C-tree",
    "acesso_rapido": "Acceso rápido a los artefactos",
    "uso_obrigatorio_privilegios": "Uso obligatorio de privilegios",
    "pontos_atencao_release": "Puntos de Atención del Release",
    "nova_home_novo_browse": "Nueva Home & Visión",
    "protheus_insights": "Protheus Insights",
    "novidades_release": "Notícias de release",
    
    // Solutions
    "solucoes_cross": "Soluciones Cross",
    "backoffice": "Backoffice",
    "recursos_humanos": "Recursos Humanos",
    "taf_automacao": "TAF Automatización Fiscal",
    "tss": "TSS",
    "solucao_segmentos": "Solución de Segmento",
    "juridico": "Legal",
    "manufatura": "Manufactura",
    "saude": "Salud",
    "varejo": "Ventas",
    "logistica": "Logística",
    "locacao": "Alquiler",
    "gestao_agricola": "Gestión Agrícola",
    "professional_services": "Servicios Profesionales",
    
    // Documentation
    "documentacao_produto": "Documentación del Producto",
    "melhorias": "Innovaciones",
    "legislacao": "Legislación",
    "manutencao": "Mantenimiento",
    
    // Content Boxes
    "framework": "Framework",
    "framework_texto": "El Framework Protheus ha experimentado varias mejoras en la versión 12.1.2510, centrándose en la optimización, la seguridad y la usabilidad para ofrecer una experiencia aún mejor a desarrolladores y usuarios finales.\n\nRelease Notes do Framework Protheus",
    "tecnologia": "Tecnología",
    "tecnologia_texto": "Principales actualizaciones tecnológicas:\n- Servidor de aplicaciones - 24.3.1.0\n- Acceso a bases de datos - 24.1.1.0\n- Alta disponibilidad del agente - Alta disponibilidad\n- Servidor de aplicaciones - Descontinuación del servidor c-tree y del servidor enlazado\n- Página principal de la aplicación web\n  Información técnica importante sobre la aplicación web.\n- Migración de SmartClient Desktop a la aplicación web\n  Información sobre las diferencias de comportamiento entre las versiones de escritorio y web, y otros consejos importantes para la migración.\n- Aplicación web - Configuración de SSL/TLS\n  Información sobre la configuración de su entorno mediante el agente y el puerto multiprotocolo.",
    "cloud": "Cloud",
    "cloud_texto": "Explora las características y la documentación de Protheus Cloud para disfrutar de una experiencia completa en la nube.\n\nRecursos disponibles:\n- Atención al cliente - TOTVS Cloud - Línea Protheus\nEncuentra respuestas a tus preguntas en cuatro fuentes de información diferentes simultáneamente, simplificando así tu búsqueda.\n\n- Lista de reproducción de videos instructivos - TOTVS Cloud\nMira videos tutoriales sobre TOTVS Cloud en nuestra lista de reproducción de YouTube.",
    
    // Central Panel
    "recursos_adicionais": "Recursos Adicionales do Protheus",
    "conheca_centrais": "Conozca los Centros Protheus",
    "avalie_fontes": "Evalúa las fuentes de tu programa en CodeAnalysis",
    "tir_robot": "TIR Test Interface Robot",
    "links_uteis": "Links útiles",
    "recursos_recomendacoes_hardware": "Recomendaciones de Hardware",
    "links_uteis_texto": "Acceda a los principales enlaces y documentación de Protheus:\n\nCiclo de vida del software - Página corporativa\nCiclo de vida del software - Línea TOTVS Protheus\nIngeniería de Protheus\nGuía de instalación de Protheus 12\nPortal del cliente\nRecomendaciones de hardware\nVersión anterior: 12.1.2410 - Entrega en octubre de 2024\nRutinas de Protheus descontinuadas",
    
    // Chatbot
    "chatbot_message": "Hola, para obtener más información sobre la versión 12.1.2510, clic aquí y ¡pregúntele a nuestro asistente virtual!",
    "chatbot_message_2610": "Hola, para obtener más información sobre la versión 12.1.2610, clic aquí y ¡pregúntele a nuestro asistente virtual!",
    "chatbot_title_2610": "Asistente Protheus Release",
    "chat_thinking_2610": "Consultando la documentación",
    
    // ChatInitModal
    "chat_init_title": "Iniciar Chat con Asistente",
    "chat_init_description": "Para iniciar una conversación con nuestro asistente virtual, necesitamos alguna información:",
    "email_label": "Correo electrónico",
    "email_placeholder": "Ingrese su correo electrónico",
    "security_verification_label": "Verificación de Seguridad",
    "initialize_chat_button": "Inicializar Chat",
    "send_verification_button": "Enviar Código de Verificación",
    "sending_verification_button": "Enviando código...",
    "initializing_button": "Inicializando...",
    "privacy_note": "Al inicializar este chat, acepta que su correo electrónico se almacene exclusivamente para mejorar su experiencia con el asistente virtual y que no se compartirá con terceros.",
    "email_required_error": "Por favor, ingrese su correo electrónico.",
    "email_invalid_error": "Por favor, ingrese un correo electrónico válido.",
    "recaptcha_required_error": "Por favor, complete el reCaptcha.",
    "recaptcha_load_error": "Error al cargar el reCaptcha. Inténtelo de nuevo.",
    "recaptcha_init_error": "Error al inicializar el reCaptcha. Recargue la página.",
    "recaptcha_expired_error": "El reCaptcha ha expirado. Por favor, complételo nuevamente.",
    "recaptcha_error": "Error en reCaptcha. Inténtelo de nuevo.",
    "chat_init_error": "Error al inicializar el chat. Inténtelo de nuevo.",
    "verification_send_error": "Error al enviar código de verificación. Inténtelo de nuevo.",
    "verification_network_error": "Error de red. Verifique su conexión e inténtelo de nuevo.",
    
    // Email Verification Modal
    "email_verification_title": "Verificar Correo Electrónico",
    "email_verification_description": "Enviamos un código de 6 dígitos a su correo electrónico:",
    "verification_code_label": "Código de Verificación",
    "verification_code_placeholder": "000000",
    "code_expires_in": "El código expira en:",
    "code_expired": "El código ha expirado.",
    "resend_code_button": "Reenviar Código",
    "verify_email_button": "Verificar Correo Electrónico",
    "verifying_button": "Verificando...",
    "verification_help_text": "¿No recibió el código? Revise su carpeta de spam o espere unos minutos.",
    "token_required_error": "Por favor, ingrese el código de verificación.",
    "token_invalid_length_error": "El código debe tener 6 dígitos.",
    "verification_failed_error": "Código inválido o expirado. Inténtelo de nuevo.",
    "verification_error": "Error de red durante la verificación. Inténtelo de nuevo.",
    "resend_failed_error": "Error al reenviar código. Inténtelo de nuevo.",
    "resend_network_error": "Error de red al reenviar código. Inténtelo de nuevo."
  }
};

// Translation function with support for React elements
export const t = (key, language = 'pt') => {
  return translations[language]?.[key] || translations.pt[key] || key;
};

// Special function for modal content that returns React elements
export const getModalContent = (key, language = 'pt') => {
  const modalComponents = {
    pt: {
      implementacoes_seguranca_modal: (
        <div>
          <h2>Implementações importantes em segurança</h2>
          
          <p>A TOTVS sempre está preocupada com a segurança em seus produtos, implementou neste release dois novos pontos que podem ter impacto nas customizações e/ou usuários do sistema.</p>
          
          <h3>Principais Implementações:</h3>
          
          <ul>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=974812561" target="_blank" rel="noopener noreferrer">Restrições na atribuição das variáveis cEmpAnt e __cUserId</a></h4>
              <p>A partir da release 12.1.2510 do Protheus, a atribuição direta às variáveis globais cEmpAnt (grupo de empresa) e __cUserId (usuário) foi bloqueada por motivos de segurança e integridade de dados. A leitura dessas variáveis continua permitida. É preciso rever as customizações que fazem este tipo de ação. Uma ferramenta que ajuda a identificar este pontos é o <a href="https://codeanalysis.totvs.com.br" target="_blank" rel="noopener noreferrer">CodeAnalysis</a>.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=981786858" target="_blank" rel="noopener noreferrer">Novas Políticas obrigatórias para criação e atualização de Senhas no Protheus</a></h4>
              <p>Com o objetivo de fortalecer a proteção do nosso sistema ERP, estamos implementando novas e mais rigorosas regras para a criação e atualização de senhas.</p>
            </li>
          </ul>
        </div>
      ),
      framework_modal: (
        <div>
          <h2>Framework Protheus</h2>
          <p>O Framework Protheus passou por diversas melhorias na Release 12.1.2510, focando em otimização, segurança e usabilidade para proporcionar uma experiência ainda melhor aos desenvolvedores e usuários finais.</p>
          <p><a href=" https://tdn.totvs.com/pages/viewpage.action?pageId=908678050" target="_blank" rel="noopener noreferrer">Release Notes do Framework Protheus</a></p>
        </div>
      ),
      tecnologia_modal: (
        <div>
          <h2>Tecnologia Protheus</h2>
          <h3>Principais Atualizações de Tecnologia:</h3>
          <ul>
            <li><h4><a href="https://tdn.totvs.com/display/tec/Application+Server+-+24.3.1.0" target="_blank" rel="noopener noreferrer">Application Server - 24.3.1.0</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com/display/tec/24.1.1.0" target="_blank" rel="noopener noreferrer">DBAccess - 24.1.1.0</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com.br/display/tec/Broker+HA+-+Alta+Disponibilidade" target="_blank" rel="noopener noreferrer">Broker HA - Alta disponibilidade</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com.br/pages/viewpage.action?pageId=990764038" target="_blank" rel="noopener noreferrer">Application Server - Descontinuação do c-tree server e bound server</a></h4></li>
            <li>
              <h4><a href="https://tdn.totvs.com/display/tec/SmartClient+HTML" target="_blank" rel="noopener noreferrer">Página principal do WebApp</a></h4>
              <p>Informações técnicas importantes sobre o WebApp.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/display/tec/4.+Migrando+do+SmartClient+Desktop+para+o+WebApp" target="_blank" rel="noopener noreferrer">Migrando do SmartClient Desktop para o WebApp</a></h4>
              <p>Informações sobre as diferenças de comportamento entre a versão Desktop e a versão Web, e mais dicas importantes para a migração.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=490323690" target="_blank" rel="noopener noreferrer">WebApp - Configuração de SSL/TLS</a></h4>
              <p>Informações para configuração de seu ambiente utilizando o Broker e a Porta Multiprotocolo.</p>
            </li>
          </ul>
        </div>
      ),
      cloud_modal: (
        <div>
          <h2>Protheus Cloud</h2>
          <p>Explore os recursos e documentação do Protheus Cloud para uma experiência completa na nuvem.</p>
          <h3>Recursos Disponíveis:</h3>
          <ul>
            <li>
              <h4><a href="https://centraldeatendimento.totvs.com/hc/pt-br/sections/360004677991-Linha-Protheus?page=1#articles" target="_blank" rel="noopener noreferrer">Central de Atendimento - TOTVS Cloud - Linha Protheus</a></h4>
              <p>Encontre respostas para suas dúvidas em quatro fontes de conhecimento diferentes ao mesmo tempo, simplificando o processo de pesquisa.</p>
            </li>
            <li>
              <h4><a href="https://www.youtube.com/playlist?list=PLXa8l0dq5zRnu6Q9xS3KXWjb8rIor2NEq" target="_blank" rel="noopener noreferrer">Playlist de Vídeos HOW TO - TOTVS Cloud</a></h4>
              <p>Assista aos vídeos tutoriais sobre o TOTVS Cloud em nossa playlist no YouTube.</p>
            </li>
          </ul>
        </div>
      ),
      links_uteis_modal: (
        <div>
          <h2>Links Úteis do Protheus</h2>
          <p>Acesse os principais links e documentações para o Protheus:</p>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/releaseview.action?spaceKey=EC&title=Ciclo+de+Vida+de+SW+-+2023" target="_blank" rel="noopener noreferrer">
                Ciclo de Vida de Software - Página Corporativa
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/display/PROT/Ciclo+de+Vida+de+Software+-+TOTVS+Linha+Protheus" target="_blank" rel="noopener noreferrer">
                Ciclo de Vida de Software - TOTVS Linha Protheus
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/display/PROT/Engenharia+Protheus" target="_blank" rel="noopener noreferrer">
                Engenharia Protheus
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=465379010" target="_blank" rel="noopener noreferrer">
                Guia de Instalação do Protheus 12
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://suporte.totvs.com/portal/p/10098/download#000006" target="_blank" rel="noopener noreferrer">
                Portal do cliente
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=563437610" target="_blank" rel="noopener noreferrer">
                Recomendações de hardware
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=836052340" target="_blank" rel="noopener noreferrer">
                Release anterior: Release 12.1.2410 - Expedição em Outubro/2024
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=704914100" target="_blank" rel="noopener noreferrer">
                Rotinas do Protheus Descontinuadas
              </a>
            </li>
          </ul>
        </div>
      )
    },
    en: {
      implementacoes_seguranca_modal: (
        <div>
          <h2>Important Security Implementations</h2>
          
          <p>TOTVS is always concerned about security in its products. In this release, it has implemented two new features that may impact customizations and/or system users.</p>
          
          <h3>Main Implementations:</h3>
          
          <ul>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=974812561" target="_blank" rel="noopener noreferrer">Restrictions on assigning cEmpAnt and __cUserId variables</a></h4>
              <p>Starting with Protheus release 12.1.2510, direct assignment to the global variables cEmpAnt (company group) and __cUserId (user) has been blocked for security and data integrity reasons. Reading these variables remains permitted. Customizations that perform this type of action should be reviewed. <a href="https://codeanalysis.totvs.com.br" target="_blank" rel="noopener noreferrer">CodeAnalysis</a> is a tool that helps identify these issues.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=981786858" target="_blank" rel="noopener noreferrer">New Mandatory Policies for Creating and Updating Passwords in Protheus</a></h4>
              <p>To strengthen the protection of our ERP system, we are implementing new, stricter rules for creating and updating passwords.</p>
            </li>
          </ul>
        </div>
      ),
      framework_modal: (
        <div>
          <h2>Protheus Framework</h2>
          <p>The Protheus Framework has undergone several improvements in Release 12.1.2510, focusing on optimization, security, and usability to provide an even better experience for developers and end users.</p>
          <p><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=908678050" target="_blank" rel="noopener noreferrer">Protheus Framework's Release Notes</a></p>
        </div>
      ),
      tecnologia_modal: (
        <div>
          <h2>Protheus Technology</h2>
          <h3>Main Technology Updates:</h3>
          <ul>
            <li><h4><a href="https://tdn.totvs.com/display/tec/Application+Server+-+24.3.1.0" target="_blank" rel="noopener noreferrer">Application Server - 24.3.1.0</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com/display/tec/24.1.1.0" target="_blank" rel="noopener noreferrer">DBAccess - 24.1.1.0</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com.br/display/tec/Broker+HA+-+Alta+Disponibilidade" target="_blank" rel="noopener noreferrer">Broker HA - High Availability</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com.br/pages/viewpage.action?pageId=990764038" target="_blank" rel="noopener noreferrer">Application Server - Discontinuation of the c-tree server and bound server</a></h4></li>
            <li>
              <h4><a href="https://tdn.totvs.com/display/tec/SmartClient+HTML" target="_blank" rel="noopener noreferrer">WebApp Home Page</a></h4>
              <p>Important technical information about the WebApp.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/display/tec/4.+Migrando+do+SmartClient+Desktop+para+o+WebApp" target="_blank" rel="noopener noreferrer">Migrating from SmartClient Desktop to the WebApp</a></h4>
              <p>Information on the behavioral differences between the Desktop and Web versions, and other important migration tips.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=490323690" target="_blank" rel="noopener noreferrer">WebApp - SSL/TLS Configuration</a></h4>
              <p>Information on configuring your environment using the Broker and the Multiprotocol Port.</p>
            </li>
          </ul>
        </div>
      ),
      cloud_modal: (
        <div>
          <h2>Protheus Cloud</h2>
          <p>Explore Protheus Cloud features and documentation for a complete cloud experience.</p>
          <h3>Available Resources:</h3>
          <ul>
            <li>
              <h4><a href="https://centraldeatendimento.totvs.com/hc/pt-br/sections/360004677991-Linha-Protheus?page=1#articles" target="_blank" rel="noopener noreferrer">Customer Service - TOTVS Cloud - Protheus Line</a></h4>
              <p>Find answers to your questions from four different knowledge sources simultaneously, simplifying the search process.</p>
            </li>
            <li>
              <h4><a href="https://www.youtube.com/playlist?list=PLXa8l0dq5zRnu6Q9xS3KXWjb8rIor2NEq" target="_blank" rel="noopener noreferrer">HOW-TO Video Playlist - TOTVS Cloud</a></h4>
              <p>Watch tutorial videos about TOTVS Cloud on our YouTube playlist.</p>
            </li>
          </ul>
        </div>
      ),
      links_uteis_modal: (
        <div>
          <h2>Useful Protheus Links</h2>
          <p>Access the main links and documentation for Protheus:</p>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/releaseview.action?spaceKey=EC&title=Ciclo+de+Vida+de+SW+-+2023" target="_blank" rel="noopener noreferrer">
                Software Lifecycle - Corporate Page
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/display/PROT/Ciclo+de+Vida+de+Software+-+TOTVS+Linha+Protheus" target="_blank" rel="noopener noreferrer">
                Software Lifecycle - TOTVS Protheus Line
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/display/PROT/Engenharia+Protheus" target="_blank" rel="noopener noreferrer">
                Protheus Engineering
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=465379010" target="_blank" rel="noopener noreferrer">
                Protheus 12 Installation Guide
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://suporte.totvs.com/portal/p/10098/download#000006" target="_blank" rel="noopener noreferrer">
                Customer Portal
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=563437610" target="_blank" rel="noopener noreferrer">
                Hardware Recommendations
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=836052340" target="_blank" rel="noopener noreferrer">
                Previous Release: Release 12.1.2410 - Expedition in October 2024
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=704914100" target="_blank" rel="noopener noreferrer">
                Discontinued Protheus Routines
              </a>
            </li>
          </ul>
        </div>
      )
    },
    es: {
      implementacoes_seguranca_modal: (
        <div>
          <h2>Implementaciones de seguridad importantes</h2>
          
          <p>TOTVS se preocupa constantemente por la seguridad de sus productos. En esta versión, ha implementado dos nuevas funciones que podrían afectar las personalizaciones o a los usuarios del sistema.</p>
          
          <h3>Implementaciones principales:</h3>
          
          <ul>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=974812561" target="_blank" rel="noopener noreferrer">Restricciones en la asignación de las variables cEmpAnt y __cUserId</a></h4>
              <p>A partir de la versión 12.1.2510 de Protheus, se ha bloqueado la asignación directa a las variables globales cEmpAnt (grupo empresarial) y __cUserId (usuario) por motivos de seguridad e integridad de los datos. La lectura de estas variables sigue permitida. Se recomienda revisar las personalizaciones que realizan este tipo de acción. <a href="https://codeanalysis.totvs.com.br" target="_blank" rel="noopener noreferrer">CodeAnalysis</a> es una herramienta que ayuda a identificar estos problemas.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=981786858" target="_blank" rel="noopener noreferrer">Nuevas políticas obligatorias para la creación y actualización de contraseñas en Protheus</a></h4>
              <p>Para reforzar la protección de nuestro sistema ERP, estamos implementando nuevas reglas más estrictas para la creación y actualización de contraseñas.</p>
            </li>
          </ul>
        </div>
      ),
      framework_modal: (
        <div>
          <h2>Framework Protheus</h2>
          <p>El Framework Protheus ha experimentado varias mejoras en la versión 12.1.2510, centrándose en la optimización, la seguridad y la usabilidad para ofrecer una experiencia aún mejor a desarrolladores y usuarios finales.</p>
          <p><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=908678050" target="_blank" rel="noopener noreferrer">Release Notes de Framework Protheus</a></p>
        </div>
      ),
      tecnologia_modal: (
        <div>
          <h2>Tecnología Protheus</h2>
          <h3>Principales actualizaciones tecnológicas:</h3>
          <ul>
            <li><h4><a href="https://tdn.totvs.com/display/tec/Application+Server+-+24.3.1.0" target="_blank" rel="noopener noreferrer">Servidor de aplicaciones - 24.3.1.0</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com/display/tec/24.1.1.0" target="_blank" rel="noopener noreferrer">Acceso a bases de datos - 24.1.1.0</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com.br/display/tec/Broker+HA+-+Alta+Disponibilidade" target="_blank" rel="noopener noreferrer">Alta disponibilidad del agente - Alta disponibilidad</a></h4></li>
            <li><h4><a href="https://tdn.totvs.com.br/pages/viewpage.action?pageId=990764038" target="_blank" rel="noopener noreferrer">Servidor de aplicaciones - Descontinuación del servidor c-tree y del servidor enlazado</a></h4></li>
            <li>
              <h4><a href="https://tdn.totvs.com/display/tec/SmartClient+HTML" target="_blank" rel="noopener noreferrer">Página principal de la aplicación web</a></h4>
              <p>Información técnica importante sobre la aplicación web.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/display/tec/4.+Migrando+do+SmartClient+Desktop+para+o+WebApp" target="_blank" rel="noopener noreferrer">Migración de SmartClient Desktop a la aplicación web</a></h4>
              <p>Información sobre las diferencias de comportamiento entre las versiones de escritorio y web, y otros consejos importantes para la migración.</p>
            </li>
            <li>
              <h4><a href="https://tdn.totvs.com/pages/viewpage.action?pageId=490323690" target="_blank" rel="noopener noreferrer">Aplicación web - Configuración de SSL/TLS</a></h4>
              <p>Información sobre la configuración de su entorno mediante el agente y el puerto multiprotocolo.</p>
            </li>
          </ul>
        </div>
      ),
      cloud_modal: (
        <div>
          <h2>Protheus Cloud</h2>
          <p>Explora las características y la documentación de Protheus Cloud para disfrutar de una experiencia completa en la nube.</p>
          <h3>Recursos disponibles:</h3>
          <ul>
            <li>
              <h4><a href="https://centraldeatendimento.totvs.com/hc/pt-br/sections/360004677991-Linha-Protheus?page=1#articles" target="_blank" rel="noopener noreferrer">Atención al cliente - TOTVS Cloud - Línea Protheus</a></h4>
              <p>Encuentra respuestas a tus preguntas en cuatro fuentes de información diferentes simultáneamente, simplificando así tu búsqueda.</p>
            </li>
            <li>
              <h4><a href="https://www.youtube.com/playlist?list=PLXa8l0dq5zRnu6Q9xS3KXWjb8rIor2NEq" target="_blank" rel="noopener noreferrer">Lista de reproducción de videos instructivos - TOTVS Cloud</a></h4>
              <p>Mira videos tutoriales sobre TOTVS Cloud en nuestra lista de reproducción de YouTube.</p>
            </li>
          </ul>
        </div>
      ),
      links_uteis_modal: (
        <div>
          <h2>Links útiles de Protheus</h2>
          <p>Acceda a los principales enlaces y documentación de Protheus:</p>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/releaseview.action?spaceKey=EC&title=Ciclo+de+Vida+de+SW+-+2023" target="_blank" rel="noopener noreferrer">
                Ciclo de vida del software - Página corporativa
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/display/PROT/Ciclo+de+Vida+de+Software+-+TOTVS+Linha+Protheus" target="_blank" rel="noopener noreferrer">
                Ciclo de vida del software - Línea TOTVS Protheus
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/display/PROT/Engenharia+Protheus" target="_blank" rel="noopener noreferrer">
                Ingeniería de Protheus
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=465379010" target="_blank" rel="noopener noreferrer">
                Guía de instalación de Protheus 12
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://suporte.totvs.com/portal/p/10098/download#000006" target="_blank" rel="noopener noreferrer">
                Portal del cliente
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=563437610" target="_blank" rel="noopener noreferrer">
                Recomendaciones de hardware
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=836052340" target="_blank" rel="noopener noreferrer">
                Versión anterior: 12.1.2410 - Entrega en octubre de 2024
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=704914100" target="_blank" rel="noopener noreferrer">
                Rutinas de Protheus descontinuadas
              </a>
            </li>
          </ul>
        </div>
      )
    }
  };

  return modalComponents[language]?.[key] || modalComponents.pt[key] || null;
};

// Function to get current language from store
export const getCurrentLanguage = () => {
  try {
    // This will be replaced by importing from language store
    const stored = localStorage.getItem('language-storage');
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.currentLanguage || 'pt';
    }
  } catch (error) {
    console.error('Error getting current language:', error);
  }
  return 'pt';
};

export default translations;